<template>
  <a href="#" @click="goBack">
    <v-icon>fal fa-chevronleft</v-icon>
    Back
  </a>
</template>
<script>



export default {
  name: 'BackButton',
  data() {
    return {

    };
  },
  props: {
    route: {
      required: false,
      type: String
    }
  },

  methods: {
    goBack() {
      return this.route ? this.$router.push({name: this.route}) : this.$router.go(-1);
    }
  },

  async mounted() {
  },

  components: {

  },
};
</script>

<style lang="scss" scoped>

@import "%/scss/_Color.sass";

  a {
  font-weight: 500;
  align-items: center;
  color: $cfkLightBlue;
}

</style>
